import type { MailboxInfo } from 'owa-client-types';
import { getMailboxInfo } from '../../selectors/mailRowDataPropertyGetter';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import type TableView from '../../store/schema/TableView';

export function getRowKeyMailboxInfoIfUnifiedInbox(
    mailboxInfo: MailboxInfo,
    tableView: TableView,
    rowkey: string
): MailboxInfo {
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        const rowKeyMailboxInfo = getMailboxInfo(rowkey, tableView);
        if (rowKeyMailboxInfo) {
            mailboxInfo = rowKeyMailboxInfo;
        }
    }
    return mailboxInfo;
}
